import { downloadFile } from '../../../../api/reportSettingsApi';
import { FileContext } from '../../../../contexts/FileContext';
import { File } from '../../../../interfaces/File';
import { SnackbarParameters } from '../../../../interfaces/Snackbar';
import { Template } from '../../../../interfaces/Templates';
import withSnackbar from '../../../../shared/components/withSnackbar';
import Summary from '../summary/Summary';
import { SovosDivider } from 'mosaic-react';
import { useContext } from 'react';

interface ImportSummaryProps {
	processId: string;
	importTemplate: Template;
	showSnackbar: (value: SnackbarParameters) => void;
	isAudit: boolean;
	file: File;
}

const ImportSummary = (props: ImportSummaryProps) => {
	const { processId, importTemplate, showSnackbar, isAudit, file } = props;
	const { getFile } = useContext(FileContext);

	const handleDownloadOriginalFile = (): void => {
		getFile(file.id)
			.then(response => {
				if (response.status === 200) {
					showSnackbar({ message: 'Download in progress', variant: 'confirmation' });
					downloadFile(file.name, new Blob([response.data]));
				} else if (response.data.errors) {
					showSnackbar({ message: response.data.errors[0].message, variant: 'error' });
				} else {
					showSnackbar({ message: 'Unable to download Original File. Please try again later.', variant: 'error' });
				}
			})
			.catch(error => console.log('Error: ', error));
	};

	return (
		<div className='content-wrapper'>
			<div style={{ marginBottom: 25 }}>
				<div className={`process-box process-box--complete${isAudit ? '__audit' : ''}`}>
					<h5 className='process-box__message'>
						Your file has been successfully uploaded {isAudit ? 'and saved.' : ''}
					</h5>
				</div>
				{!isAudit && (
					<p className='process-box__save-message'>
						Click <p className='process-box__save-message__save'> Save </p> to save your data to the database, make it
						available for filing, get tax rates, and run reports.
					</p>
				)}
			</div>

			<div className='info-container'>
				<span>Template: </span>
				<span>{importTemplate.name}</span>
			</div>

			<div className='info-container'>
				<span>Original file: </span>
				<span className='info-container__file' onClick={handleDownloadOriginalFile}>
					{file.name}
				</span>
			</div>

			<SovosDivider style={{ margin: '20px 0px' }} />
			<Summary processId={processId} showSnackbar={() => {}} />
		</div>
	);
};

export default withSnackbar(ImportSummary);
